import { AbstractModel } from ".";

export enum TribeMemberStatus {
  Preflighted = "P",
  Subscribed = "S",
}

export default class TribeMember extends AbstractModel {
  // depends on WS => either userId (publictribeservice) either id (messagingservice)
  userId?: string;
  id?: string;

  firstName?: string;

  lastName?: string;

  displayName?: string;

  messagingId?: string;

  state?: TribeMemberStatus;

  avatar?: string;

  avatarUrl?: string;

  orgMember?: boolean;

  membership?: string;

  isPreflight(): boolean {
    return this.state === TribeMemberStatus.Preflighted;
  }
}
